module.exports = __webpack_public_path__ + "img/correcao-estatica-tomografia-3.68f2afdb.png";